<input type="file" class="file-input" accept=".xlsx,.xls,.csv" (change)="onFileSelected($event)" #fileUpload>

<div class="file-upload">
       <button (click)="fileUpload.value='';fileUpload.click()" class="aet-btn-table my-1">CHOOSE FILE</button>
</div>

<div *ngIf="!importComponent.upload">
<div *ngIf="progress; else elseStatement">
       <div class="fileimg">
              <img src="assets/images/file-icon.svg">
       </div>
       <div class="progress-div">
              <div class="filename">{{fileName}}
                     <div class="cancel_upload" (click)="cancelUpload()">
                            <img src="assets/images/Path 15535.svg" alt="">
                     </div>
              </div>
              <progress max="100" [value]="progress"></progress>
              <div id="progress-per" *ngIf="progress != 100; else uploaded">{{progress + '% done'}}</div>
       </div>
</div>
</div>

<ng-template #elseStatement>
       <p class="no_file">No file chosen</p>
</ng-template>
<ng-template #uploaded>
       <p id="progress-per">Uploaded</p>
</ng-template>











<!-- <div class="progress" *ngIf="progress">
       
       <div class="progress-bar" [style.width]="progress + '%'">{{progress}}% Done</div>
</div> -->

<!-- <div class="progress"><div class="progress-bar" [value]="progress" max=100 role="progressbar" [style.width.%]="progress">
      {{progress}}%</div></div> -->



<!-- <input type="file" (change)="uploadFile($event)" />
<ng-progress></ng-progress> -->

<!-- <div class="progress">
  <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
</div> -->



<!-- <div class="progress">

    <mat-progress-bar class="progress-bar" mode="determinate"
                      [value]="uploadProgress" *ngIf="uploadProgress">
  
    </mat-progress-bar>
  
    <mat-icon class="cancel-upload" (click)="cancelUpload()" 
              *ngIf="uploadProgress">delete_forever</mat-icon>
  
  </div> -->
